export default {
      id: "volumeUp-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#volumeUp-usage",
      toString: function () {
        return this.url;
      }
    }